if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        // Use the already defined this.form instead of document.getElementById
        const form = this.form;
        const personalizationInput = form.querySelector('#PersonalizationText');
        const personalizationVariantID = '41610432675903';
        const formData = new FormData(form);
        const personalizationMessage = personalizationInput ? personalizationInput.value.trim() : '';
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity') || '1', 10);

        console.log('Main product variant ID:', variantId);
        console.log('Quantity:', quantity);
        console.log('Custom message:', personalizationMessage);

        // Step 1: Add main product using AJAX.
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            properties: {
              'Personalized Message': personalizationMessage
            }
          })
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Failed to add main product');
            }
            return response.json();
          })
          .then((mainProduct) => {
            // Step 2: If a personalization message exists, add the personalization fee product.
            if (personalizationMessage.length > 0) {
              console.log('Adding personalization product with message...');
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: personalizationVariantID,
                  quantity: 1,
                  properties: {
                    'Personalized Message': personalizationMessage,
                    'Attached To': variantId
                  }
                })
              })
                .then((response) => {
                  if (!response.ok) {
                    throw new Error('Failed to add personalization item');
                  }
                  return response.json();
                });
            } else {
              console.log('No message provided. Skipping personalization item.');
              return Promise.resolve();
            }
          })
          .then(() => {
            // Step 3: Refresh cart sections if available.
            if (!this.cart) return;
            const sections = this.cart.getSectionsToRender().map((section) => section.id);
            console.log('Refreshing cart sections:', sections);

            return fetch(`${window.Shopify.routes.root}cart?section_id=${sections.join(',')}`, {
              method: 'GET',
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
              .then((res) => res.text())
              .then((html) => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;

                this.cart.getSectionsToRender().forEach((section) => {
                  const sectionEl = tempDiv.querySelector(`#${section.id}`);
                  if (sectionEl) {
                    document.getElementById(section.id).innerHTML = sectionEl.innerHTML;
                  }
                });

                this.cart.classList.remove('is-empty');
                this.cart.open();
              });
          })
          .catch((error) => {
            console.error('Add to cart error:', error);
            this.handleErrorMessage('There was an issue adding to the cart.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });

        // Final log for debugging the items being submitted.
        console.log('Submitting to cart/add.js:', {
          items: [
            {
              id: variantId,
              quantity: quantity
            },
            ...(personalizationMessage
              ? [
                  {
                    id: personalizationVariantID,
                    quantity: 1,
                    properties: {
                      'Personalized Message': personalizationMessage,
                      'Attached To': variantId
                    }
                  }
                ]
              : [])
          ]
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
